import { render } from "./Header.vue?vue&type=template&id=3f1f06f9&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\kevintam\\Documents\\pokeraudit\\pokeraudit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__